import { NgModule, Component, Input, Inject, ChangeDetectionStrategy, PLATFORM_ID, OnChanges, SimpleChanges, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { MediaCellConfig } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'media-cell',
    templateUrl: 'media-cell.template.html',
    styleUrls: ['./media-cell.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaCell {
    @Input() item: any;
    @Input() config: MediaCellConfig;
    @Input() active: boolean;
    @Input() noLazy: boolean;
    private _hideImage: boolean = false;
    public currentTime: number = 0;
    public videoSource: string;
    public videoState: string = "in";

    private settings: any = {
        showCopy: true,
        showTags: true,
        showDetail: true,
        imageType: null
    }

    public content: any;

    public get showVideo(): boolean {
        if (this.item && (this.item.video || this.item.video_types)) {
            this.videoSource = this.item.video ? this.item.video.meta.video_types : this.item.video_types;

            return true;
        }

        return false;
    }

    public set hideImage(val: boolean) {
        if (val) {
            this.videoState = "in";
        }

        this._hideImage = val;
    }

    public get hideImage(): boolean {
        return this._hideImage;
    }

    ngOnInit() {
        Object.assign(this.settings, this.config);
        //this.setupCellContent();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.item && changes.item.previousValue !== changes.item.currentValue) {
            this.setupCellContent();
        }
    }

    setupCellContent() {
        let cell = this.item.meta || this.item;
        cell.style = this.getCellStyle();
        cell.objType = this.getObjectType(cell);
        cell.cta = this.getCta(cell);
        cell.activeCta = this.getActiveCta(cell);
        cell.detail = this.getDetailInfo(cell);
        cell.runtime = cell.runtime || cell.video && (cell.video.meta || cell.video).runtime;
        
        if (cell.video && cell.video.meta) {
            if (cell.video.meta['snipe'] && !(cell['snipe'])) {
                cell.snipe = cell.video.meta['snipe'];
            }
        }
        this.content = cell;
    }

    private getObjectType(meta: any): string {
        return (meta.obj_type || "").toLowerCase();
    }

    private getActiveCta(meta: any): string {
        return this.active && `${['video', 'episode', 'stream'].indexOf(meta.objType) > -1 ? "now playing" : ""}`;
    }

    private getCta(meta: any): string {
        return !this.active && `${['video', 'episode', 'stream'].indexOf(meta.objType) > -1 ? "play" : this.getObjectType(meta)}`;
    }

    private getCellStyle() {
        switch (this.config.size) {
            case "lg":
                return "col-sm-6"
            case "sm":
                return "col-sm-6 col-md-3"
            case "md":
            default:
                return "col-sm-6 col-md-4"
        }
    }

    private getTags(meta: any): Array<any> {
        if (meta.primary_tag_endpoint != null) {
            return [meta.primary_tag_endpoint];
        }

        return null;
    }

    private getDetailInfo(meta: any): any {
        return {
            title: meta.title,
            copy: meta.summary,
            subTitle: meta.sub_head,
            tags: this.getTags(meta),
            internal_route: meta.internal_route,
            url: meta.url,
            target: meta.target
        };
    }

    public rollCell() {
        if (this.showVideo) {
            this.hideImage = true;
        }
    }

}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/media-cell/media-cell.component.ts